export default __webpack_public_path__ + "081a78a4b171e2c1643e6989761b5a33.png";